
// export default obj => {
//     return new Promise((resolve, reject) => {
//         // ~ console.log(obj.name, obj.method);
//         resolve(when_available);
//         reject('bad');
//         });
//     };

var _debug = false;
// ~ var _debug = true;

async function console_if_debug() {
  if (_debug) {
    await console.log(arguments);
  }
}

function get_language(){
  return document.getRootNode().documentElement.lang || window.navigator.userLanguage || window.navigator.language;
}


function hide_on_scroll(event, select, max, min){
  var _top = document.documentElement.scrollTop;
  //  ,
  //  _min = 0,
  //  _max = 500;
  //  _select = [
  //    '#qcCmpUi',
  //    ];
  if (_top >= max || _top == min){
    let _class = 'hidden';
    for (let _ele of select) {

      let _element = document.querySelector(_ele);
      if (_element){
        _element = _element.classList;
        if (_element.contains(_class) && _top == min){
          // show element
          _element.toggle(_class);
        } else if (!_element.contains(_class) && _top >= max){
          // hide element
          _element.toggle(_class);
        }
      }
    }
  }
};


function set_hide_on_scroll(selectors, max, min){
  document.addEventListener(
    'scroll',
    function(event){
      hide_on_scroll(event, selectors, max, min);
      }
    );
};


/**
 * for wait for dinamic dom element load
 */
function _raf_async() {
  return new Promise(resolve => {
    requestAnimationFrame(resolve); //faster than set time out
  });
}

// check selector in document
function check_element(selector) {
  const querySelector = document.querySelector(selector);
  if (querySelector === null) {
    return _raf_async().then(() => check_element(selector));
  } else {
    return Promise.resolve(querySelector);
  }
}

// use animationframe
async function _use_animation_frame(name, callback) {
  if (window[name]) {
    try {
      await console_if_debug('Running:', name, callback.name);
      // ~ await console.log('Running:', name, callback.name);
      await callback(window[name]);
    } catch (err) {
      await console.log(err);
      // ~ console.log(name, 'not found!')
      await requestAnimationFrame(()=>{
        when_available(name, callback)
      });
    }
  } else {
    // do each second
    // dont work
    // call_each_n_miliseconds(1000, ()=>{
    //   when_available(name, callback)
    //   });
    when_available(name, callback);
    // await requestAnimationFrame(()=>{
    //   when_available(name, callback)
    // });
  }
}

var when_available = async function(name, callback) {
  /*
   * dont needed
   */
  /*
  function _use_timeout() {
    var interval = 1000 / 60; // ms
    function _window_method() {
      if (window[name]) {
        try {
          callback(window[name]);
        } catch (err) {
          console.log(name, 'not found!')
        }
      } else {
          window.setTimeout(arguments.callee, interval);
      }
    };
    window.setTimeout(_window_method, interval);
  };
  */

  // call method
  // ~ await call_each_n_miliseconds(1000, _use_animation_frame)
  await requestAnimationFrame(()=>{
    _use_animation_frame(name, callback);
  });

};

// ~ var when_document_ready = async function(callback) {
var when_document_ready = function(callback) {
  // ~ console.log(callback);

  // ~ async function _use_animation_frame() {
  function _use_animation_frame() {
    if (document.readyState === 'complete') {
      try {
        // ~ console.log(callback);
        callback();
        // ~ await callback();
      } catch (err) {
        console.log(err, callback);
        // ~ await console.log(err, callback);
        // ~ console.log(name, 'not found!')
        when_document_ready(callback);
        // ~ await when_document_ready(callback);
      }
    } else {
      when_document_ready(callback);
      // ~ await when_document_ready(callback);
    }
  }

  // call method
  requestAnimationFrame(_use_animation_frame);
  // ~ await requestAnimationFrame(_use_animation_frame);
};

function call_each_n_miliseconds(miliseconds, callback){

   // ~ window.addEventListener('DOMContentLoaded', (event) => {
    // ~ when_document_ready(() => {
      var _time = Date.now(), _count = 0;
      // ~ async function draw_each_miliseconds(){
      function draw_each_miliseconds(){
        var _new = Date.now(),
          _re = _new - _time;
        _count++;

        if(_re >= miliseconds){
          if (_count > 10){
            _count = 0;
            console_if_debug('call', callback);
          };
          requestAnimationFrame(callback);
          _time = Date.now();
        }
         // ~ else {
        // if this in else, miner dont countdown
        requestAnimationFrame(draw_each_miliseconds);
        // ~ }
      };
      draw_each_miliseconds();
      // ~ });
  // ~ });

};

function set_previous_css(previous, element, orcss, props){
  [].forEach.call(
    Object.keys(props),
    function(e, i){
      if (element) {
        // ~ console.log(element, orcss);
        previous[e] = element.style[e] || orcss[e];
        // ~ previous[e] = element.css(e) || orcss[e];
      }
    });
}

function set_css_props(element, props){
  [].forEach.call(
    Object.keys(props),
    function(e, i){
      if (element) {
        element.style[e] = props[e];
        // ~ element.css(e, props[e]);
      }
    });
}

function convertToHashtag(text){
  return text
    .replace(/ /g,'');
}

function convertToPick(Text, sep){
  return sep + Text
    //~ .replace(/  +/g, ' ')
    .replace(/\n|\r\n|\n/g, ' ')
    .replace(/\s\s+/g, ' ')
    .replace(/ - /g, '-')
    .replace(/---/g, ' 🆚 ')
    //~ .toLowerCase()
    //~ .replace(/ /g,'')
    //~ .replace(/[^\w-]+/g,'')
    .trim()
    ;
}

function convert_facebook_url(url){
  return url
    //~ .replace(/  +/g, ' ')
    .replace(/\//g, '%2F')
    .replace(/:/g, '%3A')
    .trim()
    ;
  }

// Find first ancestor of el with tagName
// or undefined if not found
function parent(el, tagName) {
  tagName = tagName.toLowerCase();
  let _re;
  while (el && el.parentNode) {
    // ~ console.log('parent ele:', el);
    el = el.parentNode;

    if (tagName.startsWith('.')){
      // find class value
      if (el.classList.contains(tagName.slice(1))) {
        _re = el;
        break;
      }
    } else if (tagName.indexOf('.') > 0){
      // find tagname.class value
      // ~ console.log('parent ele:', el, el.classList.contains(tagName.split('.').slice(1)), el.tagName , tagName.split('.')[0]);
      try {
        if (el.classList.contains(
          tagName.split('.').slice(1)) && el.tagName.toLowerCase() == tagName.split('.')[0]
          ) {
          _re = el;
          break;
        }
      } catch {
        break;
      };
    } else {
      // find tagname
      if (el.tagName.toLowerCase() == tagName) {
        _re = el;
        break;
      }
    }
  }

  // Many DOM methods return null if they don't
  // find the element they are searching for
  // It would be OK to omit the following and just
  // return undefined
  return _re;
}

let ajax = (function() {
  var _http = new XMLHttpRequest(),
    _callback,
    _result,
    _private = {},
    mpublic = {};

  _http.onreadystatechange = function() {
    if (_http.readyState == XMLHttpRequest.DONE) {
      // XMLHttpRequest.DONE == 4
      let _re = null;
      if (_http.status == 200) {
        // document.getElementById("myDiv").innerHTML = _http.responseText;
        // _callback(_http.responseText);
        _re = JSON.parse(_http.responseText);
      }
      else if (_http.status == 400) {
        _re = 'There was an error 400'
      }
      else {
        _re = 'something else other than 200 was returned';
      }
      _result = _re;
      _private._resolve(_re);
      // ~ return _re;
    }
  };

  function _get_result(){
    return _result;
  }
  mpublic.result = _get_result;

  function _get(url){

    return new Promise(function(resolve, reject){
      _private._resolve = resolve;
      _http.open("GET", url, true);
      _http.send();
      // ~ resolve(_result);
      });
  };
  mpublic.get = _get;

  return mpublic;

});

let template = (function() {
  var _ext = {
      js: '.js',
      },
    _names = {
      path: '/templates/blackmostros1',
      js: 'javascript',
      jsfile: 'blackmostros',
      worker: 'service-worker.min',
      },
    _pathname = {
      js: `${_names.path}/${_names.js}/${_names.jsfile}.`,
      },
    _script = {
      url:{
        search: `${_uri}${_pathname.js}search${_ext.js}`,
        worker: `${_uri}/${_names.worker}${_ext.js}`,
        // errors with scope
        // ~ worker: `${_uri}${_names.path}/${_names.js}/${_names.worker}${_ext.js}`,
        },
      },
    mpublic = {};

  mpublic.path = _names.path;
  mpublic.pathname = _pathname;
  mpublic.script = _script;

  return mpublic;
  })();

function run_site_ads(index){
  /*
  * google ads
  *
  */
  // one by each ad
  // repeat don't needed
  // ~ if (window.adsbygoogle != undefined) {
  if (window.adsbygoogle != undefined) {
    var _abg = (adsbygoogle = window.adsbygoogle || []);
    if (index == 0) {
      try {
        // next line only push mobile ads
        _abg.push({
          google_ad_client: "ca-pub-4551634866328770",
          // for better ads
          // dont uncomment next line
          // ~ enable_page_level_ads: true
        });
      } catch (err) {
        console_if_debug(err);
      }
      // next line push head ad
      try {
        _abg.push({});
      } catch (err) {
        console_if_debug(err);
      }
    } else {
      try {
        _abg.push({});
      } catch (err) {}
    }
  }
}

var fetch_style = function(url) {
  // Old-school:
  //var a2 = a.map(function(s){ return s.length });
  // ECMAscript 6 using arrow functions
  //var a3 = a.map( s => s.length );

  return new Promise(function(resolve, reject){

    function _add_css_head_link() {
      var link = document.createElement('link');

      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.onload = function() {
        resolve();
        };
      link.href = url;

      var headScript = document.querySelector('script');
      headScript.parentNode.insertBefore(link, headScript);

    }
    // ~ _add_css_head_link();

    function _add_style_element(){

      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function() {
          if (this.readyState == 4 && this.status == 200) {

            /*
             * do appendChild when document is ready
             * and use
             *
             *
             */

            /**
             * If run as a requestAnimationFrame callback, this
             * will be run at the start of the frame.
             */
            function updateScreen(time) {
              // Make visual updates here.
              var style = document.createElement('style');
              style.innerHTML = xhttp.responseText;
              var body = document.querySelector('body');
              body.appendChild(style);

              // Typical action to be performed when the document is ready:
              // ~ document.getElementById("demo").innerHTML = xhttp.responseText;

            }

            requestAnimationFrame(updateScreen);
          }
      };
      xhttp.open("GET", url, true);
      xhttp.send();

    }
    _add_style_element();

  });

  /*
  return new Promise((resolve, reject) => {
    let link = document.createElement('link');

    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.onload = function() {
      resolve();
      };
    link.href = url;

    var headScript = document.querySelector('script');
    headScript.parentNode.insertBefore(link, headScript);
  });
  */

};

/*
 * next  function add javascript code to html
 *
 *
 *
 */
var fetch_script = function(url) {
  // Old-school:
  //var a2 = a.map(function(s){ return s.length });
  // ECMAscript 6 using arrow functions
  //var a3 = a.map( s => s.length );

  return new Promise(function(resolve, reject){

    var xhttp = new XMLHttpRequest();

    /*
     * do appendChild when document is ready
     * and use
     *
     *
     */

    /**
     * If run as a requestAnimationFrame callback, this
     * will be run at the start of the frame.
     */
    function updateScreen() {

      var script = document.createElement('script');
      var body = document.querySelector('body');

      script.innerHTML = xhttp.responseText;
      console_if_debug(script);
      // long time
      body.appendChild(script);

      // Typical action to be performed when the document is ready:
      // ~ document.getElementById("demo").innerHTML = xhttp.responseText;
      resolve();
    }

    function _add_script_element(){

      xhttp.onreadystatechange = function() {
          if (this.readyState == 4 && this.status == 200) {
            // requestAnimationFrame(()=>{
            //   Promise.resolve().then(_eval_js_code);
            //   });

            // next line 223 missing samples
            // requestAnimationFrame(_eval_js_code);

            requestAnimationFrame(updateScreen);
          } else if (this.status == 404) {
            reject(new Error("Resource not found."));
          }
      };
      xhttp.open("GET", url, true);
      xhttp.send();

    }
    _add_script_element();

  });

};

/*
 * show error messages
 *
 */
var show_error_message = function(
  code, detail=undefined, lang=undefined
  ) {
  let _lang = lang;
  if (_lang == undefined){
    _lang = get_language();
    }
  let message = {
    'es': {
      500: 'Error en servidor inesperado. Vuelve a intentarlo en otro momento.',
      'parameter_invalid_integer': 'Entero inválido',
      },
    'en': {
      500: 'Unexpected server error. Try again later.',
      'parameter_invalid_integer': 'Invalid integer',
      },
    },
    _msg = `${message[_lang][code]}`;

  try {
    if (Joomla) {
      Joomla.renderMessages({'error': [_msg]});
    }
  } catch (e) {}
  console_if_debug(code, detail);

}

export {
    when_available,
    check_element,
    set_previous_css,
    set_css_props,
    when_document_ready,
    call_each_n_miliseconds,
    convertToHashtag,
    convertToPick,
    convert_facebook_url,
    parent,
    template,
    ajax,
    run_site_ads,
    fetch_style,
    fetch_script,
    console_if_debug,
    get_language,
    set_hide_on_scroll,
    show_error_message,
}
